/* ==========================================================================
   SHOESLI V5 — cart drawer
   ========================================================================== */
(function () {
  'use strict';

  const SECTION = 'v5-cart-drawer';
  let drawer = null;

  function panel() { return document.getElementById('V5CartDrawer'); }
  function overlay() { return document.querySelector('[data-v5-cart-overlay]'); }

  function build() {
    const p = panel();
    if (!p || !window.V5Drawer) return null;
    drawer = new window.V5Drawer(p, overlay());
    return drawer;
  }

  /* Replace the drawer markup in place, keeping it open and focused. */
  function replaceMarkup(html) {
    const next = new DOMParser().parseFromString(html, 'text/html');
    const nextPanel = next.getElementById('V5CartDrawer');
    const current = panel();
    if (!nextPanel || !current) return;

    const wasOpen = current.classList.contains('is-open');
    current.innerHTML = nextPanel.innerHTML;
    if (wasOpen) current.classList.add('is-open');

    // Header bubble
    const nextCount = next.querySelector('.v5-cart__n');
    const bubble = document.querySelector('[data-cart-count]');
    if (bubble && nextCount) {
      bubble.textContent = nextCount.textContent.replace(/[()]/g, '').trim();
    }
  }

  async function refresh() {
    const res = await fetch(`${window.location.pathname}?section_id=${SECTION}`);
    replaceMarkup(await res.text());
  }

  async function change(line, quantity) {
    const p = panel();
    p.classList.add('is-busy');
    try {
      const res = await fetch(window.routes.cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: SECTION, sections_url: window.location.pathname }),
      });
      const data = await res.json();
      if (data.sections && data.sections[SECTION]) replaceMarkup(data.sections[SECTION]);
      else await refresh();
    } catch (e) {
      await refresh();
    } finally {
      p.classList.remove('is-busy');
    }
  }

  /* Crocs 99.90 upsell — one tap on a size adds that variant; the drawer then
     re-renders through the same v5:cart:added path the product page uses. */
  async function addCrocs(btn) {
    const box = btn.closest('[data-v5-croc]');
    const err = box && box.querySelector('[data-v5-croc-error]');
    btn.classList.add('is-loading');
    if (err) err.hidden = true;
    try {
      const res = await fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
        body: JSON.stringify({
          items: [{ id: Number(btn.dataset.v5CrocsAdd), quantity: 1 }],
          sections: SECTION,
          sections_url: window.location.pathname,
        }),
      });
      const data = await res.json();
      if (data.status) {
        if (err) { err.textContent = data.description || data.message || ''; err.hidden = false; }
        return;
      }
      document.dispatchEvent(new CustomEvent('v5:cart:added', { detail: { sections: data.sections } }));
    } catch (e) {
      if (err) { err.textContent = (window.cartStrings && window.cartStrings.error) || 'משהו השתבש, נסו שוב'; err.hidden = false; }
    } finally {
      btn.classList.remove('is-loading');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!panel()) return;
    build();

    document.querySelectorAll('[data-v5-cart-open]').forEach((el) =>
      el.addEventListener('click', (e) => {
        e.preventDefault();
        drawer.open(el);
      })
    );

    // Delegated so it survives every re-render of the drawer body.
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-v5-cart-close]')) {
        drawer.close();
        return;
      }
      const croc = e.target.closest('[data-v5-crocs-add]');
      if (croc && panel().contains(croc)) {
        e.preventDefault();
        addCrocs(croc);
        return;
      }
      const qty = e.target.closest('[data-v5-qty]');
      if (qty && panel().contains(qty)) {
        e.preventDefault();
        change(Number(qty.dataset.line), Number(qty.dataset.v5Qty));
      }
    });
  });

  document.addEventListener('v5:cart:added', (e) => {
    const sections = e.detail && e.detail.sections;
    if (sections && sections[SECTION]) replaceMarkup(sections[SECTION]);
    else refresh();
    if (drawer) drawer.open();
  });
})();
